import { queryClient } from 'lib/react-query'
import moment from 'moment'
import { InfiniteData } from 'react-query'
import { InfinityNewType, TGetNotification } from 'types'

const PER_PAGE = 50

const updateCacheData = (messages: TGetNotification[]): void => {
 const newData: InfinityNewType<TGetNotification>[] = []

 for (let i = 0; i < messages.length; i += PER_PAGE) {
  const currentPage: InfinityNewType<TGetNotification> = {
   data: messages.slice(i, i + PER_PAGE),
   next: i + 2,
  }
  newData.push(currentPage)
 }

 queryClient.setQueryData<InfiniteData<InfinityNewType<TGetNotification>>>(
  'all-notification',
  (data) => ({
   pageParams: data?.pageParams || [],
   pages: newData,
  }),
 )
}

export const removeNotificationFromCache = (id: any): void => {
 const cache =
  queryClient.getQueryData<InfiniteData<InfinityNewType<TGetNotification>>>(
   'all-notification',
  )
 if (cache?.pages && cache?.pages.length > 0) {
  const messages =
   (cache?.pages.map((v) => v.data).flat() as TGetNotification[]) || []
  updateCacheData(messages.filter((v) => v.id !== id))
 }
}

export const ReadNotifyFromCache = (id: any): void => {
 const cache =
  queryClient.getQueryData<InfiniteData<InfinityNewType<TGetNotification>>>(
   'all-notification',
  )
 if (cache?.pages && cache?.pages.length > 0) {
  const messages =
   (cache?.pages.map((v) => v.data).flat() as TGetNotification[]) || []
  const index = messages.findIndex((v) => v.id === id)
  messages[index] = {
   ...messages[index],
   read_at: moment().format(),
  }
  updateCacheData(messages)
 }
}

export const updateNotificationChatActionInCache = (
 id: any,
 status: any,
): void => {
 const cache =
  queryClient.getQueryData<InfiniteData<InfinityNewType<TGetNotification>>>(
   'all-notification',
  )
 if (cache?.pages && cache?.pages.length > 0) {
  const messages =
   (cache?.pages.map((v) => v.data).flat() as TGetNotification[]) || []

  const index = messages.findIndex((v) => v.id === id)
  if (index !== -1) {
   messages[index] = {
    ...messages[index],
    data: {
     ...messages[index].data,
     status,
    },
   }
   updateCacheData(messages)
  }
 }
}
